module.exports = __webpack_public_path__ + "files/f9915fd28faa4dc100e783da93242ace.png";